// Membership program — client-side helpers (mirror of backend services/memberships.py).
// The backend is authoritative on save; these power the live editor preview.

export const MEMBERSHIP_TERMS = ["1yr", "2yr", "3yr", "4yr", "5yr", "lifetime"];

const TERM_LABELS = {
  "1yr": "1 Year",
  "2yr": "2 Years",
  "3yr": "3 Years",
  "4yr": "4 Years",
  "5yr": "5 Years",
  lifetime: "Lifetime",
};

export const termLabel = (t) => TERM_LABELS[t] || t || "";

const round2 = (v) => Math.round((Number(v) || 0) * 100) / 100;

export const isMemberActive = (customer) => {
  const info = customer?.membershipInfo;
  if (!info || info.status !== "active") return false;
  if (!info.expiresAt) return true; // lifetime
  const exp = new Date(info.expiresAt);
  return Number.isNaN(exp.getTime()) ? true : exp > new Date();
};

export const activePlanId = (customer) =>
  isMemberActive(customer) ? customer?.membershipInfo?.planId || null : null;

/**
 * Apply a plan's member discount to line items for live preview.
 * @param {Array} lines  line items (unitPrice = LIST price)
 * @param {Object|null} plan  the membership plan whose discount applies
 * @param {Object} pbMap  { pricebookId: { memberExempt, memberPrice } }
 * @returns {{ lines, savings }} lines get listUnitPrice + memberUnitPrice + memberDiscounted
 */
export const applyMembershipToLines = (lines, plan, pbMap = {}) => {
  const pct = Number(plan?.discountPct || 0);
  let savings = 0;
  const out = (lines || []).map((li) => {
    const qty = Number(li.qty) || 0;
    const base = li.listUnitPrice != null ? Number(li.listUnitPrice) : Number(li.unitPrice) || 0;
    let member = base;
    let discounted = false;
    if (plan && !li.isMembershipFee) {
      const pb = li.pricebookId ? pbMap[li.pricebookId] : null;
      if (pb && pb.memberExempt) {
        member = base;
      } else if (pb && pb.memberPrice != null) {
        member = Number(pb.memberPrice);
        discounted = member < base;
      } else if (pct > 0) {
        member = round2(base * (1 - pct / 100));
        discounted = member < base;
      }
    }
    savings += Math.max(0, base - member) * qty;
    return { ...li, listUnitPrice: round2(base), memberUnitPrice: round2(member), memberDiscounted: discounted };
  });
  return { lines: out, savings: round2(savings) };
};
